<template>
  <!-- pricing Section -->
  <section class="price-sections-seven blog-sec-seven">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="section-heading section-heading-seven aos" data-aos="fade-up">
            <h2>Our Recent Blog</h2>
            <p>Here’s a compelling blog description designed to attract readers and provide a clear idea of what they can expect from your blog:</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="owl-carousel our-recent-blog">
            <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
              <Slide v-for="item in indexsevenpricing" :key="item.id">
                <div class="blog blog-new flex-fill aos" data-aos="fade-up">
                  <div class="blog-image">
                    <router-link to="/blogs/blog-details"><img class="img-fluid" :src="require(`@/assets/img/blog/${item.image}`)" alt="Post Image"></router-link>
                    <div class="date">
                      25<span>Dec</span>
                    </div>
                    <ul class="blog-item">
                      <li>
                        <div class="post-author">
                          <a href="#"><i class="feather-user"></i><span>{{item.name}}</span></a>
                        </div>
                      </li>
                      <li><i class="feather-message-square"></i>Comments (5)</li>
                    </ul>
                  </div>
                  <div class="blog-content text-start mb-0">
                    <h3 class="blog-title">
                      <router-link to="/blogs/blog-details">{{item.title}}</router-link>
                    </h3>
                    <p>{{item.content}}.</p>
                  </div>
                </div>
              </Slide>
              <template #addons>
                <Pagination />
              </template>
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /pricing Section -->
</template>

<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import indexsevenpricing from "@/assets/json/indexsevenpricing.json";
import "vue3-carousel/dist/carousel.css";
export default {
  data() {
    return {
      indexsevenpricing: indexsevenpricing,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
        loop: true,
        margin: 24,
      },

      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 991px and up
        991: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
};
</script>
